<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div
          v-for="item in input.options"
          v-bind:key="item.value"
          :style="
            input.class == 'block'
              ? 'display:block'
              : 'display:inline-block;margin-right:1.5rem'
          "
        >
          <div class="checkbox custom-control custom-checkbox" :style="input.disabled || input.readonly ? 'pointer-events: none;' : ''">
            <input
              type="checkbox"
              :name="input.name"
              class="custom-control-input"
              :id="input.name+item.value"
              @change="(e)=>handleChange(e,item.value)" :checked="values==item.value"
              v-if="input.single"
            />
             <input
              type="checkbox"
              :name="input.name"
              class="custom-control-input"
              :id="input.name+item.value"
              @change="(e)=>handleChange(e,item.value)" :checked="values.indexOf(item.value)>-1"
              :disabled="input.disabled"
              :readonly="input.readonly"
              v-else
            />
            <label class="custom-control-label" :for="input.name + item.value">{{
              item.label
            }}</label>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
let id = Math.random(1024);
export default {
  name: "InputCheckboxOld",
  components: {},
  props: {
    input: Object,
    value:[Array,Number,String]
  },
  data: function() {
    if(this.input.single){
      return {
        id: id,
        values:null
      };
    }
    else{
      return {
        id: id,
        values:[]
      };
    }
  },
  methods: {
    handleChange(e,value) {
      if(this.input.single){
        if(e.target.checked){
          if(this.values!=value){
            this.values=value;
          }
        }
        else{
          this.values=null;
        }
        e.target.value=this.values;
        this.$emit("handleChange", e);
      }
      else{
        if(e.target.checked){
          if(this.values.indexOf(value)==-1){
            this.values.push(value);
          }
        }
        else{
          this.values=this.values.filter(val=>{
            return val != value;
          });
        }
        e.target.value= Array.isArray(this.values) ?  this.values : this.values.split(',');

        this.$emit("handleChange", e);
      }

    }
  },mounted:function(){
    if(this.input.single){
      this.values=this.value;
    }
    else{
      this.values = Array.isArray(this.value) ? this.value : this.value.split(',');
    }
  }
};
</script>
